import React from 'react';
import { IntlMessages } from '../../../../helper/langHelper';
import { ModalGap, ModalWrapper } from '../../../../services/settings/appStyle/global.style';
import { Modal } from '../../../../Components/uielements';
import { useNavigate } from 'react-router-dom';
import { OptionItem, OptionList, OptionText } from '../style';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export const EnvdFormSelectModal = ({ onClose, isOpen }) => {
  const navigate = useNavigate();

  // Array of livestock options
  const livestockOptions = [
    { id: 'cattle', name: 'Cattle', route: '/envd/form?formType=cattle' },
    { id: 'sheep', name: 'Sheep', route: '/envd/form?formType=sheep' },
    { id: 'goats', name: 'Goats', route: '/envd/form?formType=goats' },
    { id: 'bobby-calves', name: 'Bobby Calves', route: '/envd/form?formType=bobbycalves' },
    {
      id: 'harvested-rangeland-goats',
      name: 'Harvested Rangeland Goats',
      route: '',
    },
  ];

  const handleOptionClick = (route) => {
    navigate(route);
    onClose();
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={<IntlMessages id="modal.choose.envd.title" />}
        isNotCapitalize={true}
      >
        <ModalWrapper>
          <ModalGap>
            <OptionList>
              {livestockOptions.map((option) => (
                <OptionItem key={option.id} onClick={() => handleOptionClick(option.route)}>
                  <OptionText>{option.name}</OptionText>
                  <ArrowForwardIcon style={{ color: '#7AEAA7' }} />
                </OptionItem>
              ))}
            </OptionList>
          </ModalGap>
        </ModalWrapper>
      </Modal>
    </>
  );
};

export default EnvdFormSelectModal;
